<template>
    <section v-if="!isSuccess" class="detail app-width cf pdg" data-pdgb="80" data-offer="true">
        <h1 class="title">{{ localizer.get("Account.Common.Edit_Title") }}</h1>
        <div class="account mrg" data-mrgt="20">
            <div class="login">
                <div v-if="options" class="form">
                    <div class="item">
                        <fieldset class="fieldset mrg" data-mrgt="20" :disabled="isLoading">
                            <div class="form-items cf">
                                <div v-if="options.isUserName" class="item">
                                    <div class="control">
                                        <label class="label" for="UserName">{{ localizer.get("Account.Common.UserName") }}</label>
                                        <input type="text" id="UserName" v-model.lazy="formData.userName" autocomplete="email" :class="[{ 'input-validation-error': isValidationError('UserName') }, 'textbox short']" />
                                        <span class="valid-sign">*</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="control">
                                        <label class="label" for="Email">{{ localizer.get("Account.Common.Email") }}</label>
                                        <input type="email" id="Email" v-model.lazy="formData.email" autocomplete="email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox short']" />
                                        <span class="valid-sign">*</span>
                                    </div>
                                </div>
                                <div class="item">
                                    <div class="control">
                                        <label class="label" for="Password">{{ localizer.get("Account.Common.Password") }}</label>
                                        <input type="password" id="Password" value="*********" :class="[{ 'input-validation-error': isValidationError('Password') }, 'textbox short']" disabled />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="fieldset">
                            <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                                <ul>
                                    <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                                </ul>
                            </div>
                            <div class="form-items" data-type="buttons">
                                <div class="item calltoaction">
                                    <button id="ButtonSubmit" class="button" @click="submitForm()" :disabled="isLoading"><span class="lable">{{ localizer.get("Account.Common.Button_Next") }}</span></button>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section v-else data-pdgb="80" data-offer="true" class="detail app-width cf pdg">
        <h1 class="title">{{ localizer.get("Account.Common.StatusMessage_Edit_Title") }}</h1>
        <div data-mrgt="20" data-line="false" class="subtitle mrg">
            <h2 class="txt">{{ localizer.get("Account.Common.ProfileUpdateSuccess") }}</h2>
        </div>
        <div data-mrgt="40" class="calltoaction mrg">
            <a href="/" class="button">{{ localizer.get("Account.Common.Button_Next") }}</a>
        </div>
    </section>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    returnUrl?: string
}>();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isSuccess = ref(false);
const options = ref<any>(null);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

async function getData() {
    const response = (await Axios.post(routes.Account_Edit_GetData)).data;
    formData.value = response;
    isLoading.value = false;
}

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    await getData();
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    formData.value.returnUrl = props.returnUrl;

    try {
        await Axios.post(routes.Account_Edit, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>